export default "__VITE_ASSET__CkS8ccHN__"